import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["validity", "modalButton"];

  initialize() {
    this.interceptBootstrapModal();
  }

  // New method to intercept Bootstrap modal opening
  interceptBootstrapModal() {
    if (!this.hasModalButtonTarget || !this.hasValidityTarget) return;

    this.modalButtonTarget.addEventListener("click", (event) => {
      const isValid = this.checkValidityTargets();

      if (!isValid) {
        // Prevent modal from opening
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  checkValidityTargets() {
    const invalidInputs = this.validityTarget.querySelectorAll(".is-invalid");

    return invalidInputs.length === 0;
  }
}
